export enum SubmitButtonTitle {
  LOGIN_TO_ANSWER = 'Login to answer..',
  SIGN_UP_LOGIN_TO_ANSWER = 'Signup/Login to answer',
  JOIN_THIS_ROOM = 'Join this room',
  CORRECT_ANSWER = 'Correct Answer',
  DEFAULT = 'Submit',
  COMPLETE = 'Complete',
}

export enum AnswerPlaceholder {
  LOGIN_TO_ANSWER = 'Login to answer..',
  SIGN_UP_LOGIN_TO_ANSWER = 'Signup/Login to answer',
  JOIN_THIS_ROOM = 'Join this room',
  NO_ANSWER_NEEDED = 'No answer needed',
}

export enum AnswerErrorMessage {
  TOO_SHORT = 'Your answer is too short. Please make sure it matches the answer format represented by underscores.',
  INCORRECT = 'Your answer is incorrect. Please ensure it follows the answer format represented by underscores, check for typos, and try again.',
  NON_ENGLISH = 'Uh-oh! The answer you provided may not be in English. Please review it and try again.',
}
